<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="stayList"
        item-key="id"
        class="table-rounded"
        :search="search"
        :filters="filtreTable"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
    >
      <template #top>
        <v-toolbar flat>
          <v-toolbar-title>Liste des Séjours</v-toolbar-title>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-row style="margin-left: 1.5rem; margin-right: 1.5rem">
          <!--          class="d-flex"-->
          <v-col
              cols="12"
              sm="4"
          >
            <v-select
                v-model="filtreTable"
                dense
                :items="listStatus"
                label="Filtré par status"
                outlined
                :item-value="'code'"
                :item-text="'name'"
                @change="filterStay"
            ></v-select>
          </v-col>
          <!--          class="d-flex"-->
          <v-col
              cols="12"
              sm="4"
          >
            <v-btn
                color="primary"
                dark
                class="mb-2"
                @click="createStay()"
            >
              Nouveau Séjour
            </v-btn>
          </v-col>
          <v-col
              cols="12"
              sm="4"
          >
            <v-btn
                v-if="stayList.length > 0"
                color="primary"
                dark
                class="mb-2"
                @click="exportToExcel"
            >
              Exporter au format Excel
            </v-btn>
          </v-col>
          <!--          class="d-flex"-->
          <v-col
              cols="12"
              sm="4"
          >
            <v-text-field
                v-model="search"
                dense
                append-icon="mdi-magnify"
                label="Rechercher un séjour"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template #item.stays_status="{item}">
        <v-chip
            small
            :color="statusColor[status[item.stays_status]]"
            class="font-weight-medium"
        >
          {{ status[item.stays_status] }}
        </v-chip>&emsp;
      </template>
      <template
          #expanded-item="
          { headers, item }"
      >
        <td
            :colspan="headers.length"
            style="width: 100%"
        >
          Details du Séjour Numéro: {{ item.id }}<br/>
          Montant restant a payer : <strong>{{ item.stays_remaining_amount }} FCFA </strong>&emsp;
          Soldé : <strong>{{ item.stays_pay_off ? 'oui' : 'non' }}</strong>&emsp;
          Occupants: <strong>{{ item.stays_number_of_occupants }}</strong>&emsp;
          Reduction: <strong>{{ item.stays_reduce }} FCFA</strong>
          Enregistré avec le compte: <strong>{{ item.user ? item.user.email : "client" }}</strong><br/>&emsp;
          Status :
          <v-chip
              small
              :color="statusColor[status[item.stays_status]]"
              class="font-weight-medium"
          >
            {{ status[item.stays_status] }}
          </v-chip>&emsp;
          Date entrée:<strong>{{ item.stays_enter_date }}</strong>&emsp;
          Date de sortis:<strong>{{ item.stays_leaving_date }}</strong>&emsp;
          Nombre de Nuitée:<strong>{{ item.stays_number_of_days }}</strong><br>
          Payement effectuer: <br>
          <div
              v-for="paiment in item.stay_payments"
              :key="paiment.id"
          >
            <span>Date de paiement : <strong>{{ paiment.pay_stay_date }}</strong></span>&emsp;
            <span>Montant du paiement: <strong>{{ paiment.pay_stay_amount }} FCFA</strong></span>
          </div>
          <br/>
          Payement total effectuer: <strong>{{ totalPay(item.stay_payments) }} FCFA</strong>
          <div
              v-show="checkOption(item)"
              style="display: flex; justify-content: space-between; align-items: start; padding: 1rem"
          >
            <v-btn
                color="primary"
                small
                @click="modified_stay(item)"
            >
              Modifier
            </v-btn>
            <v-btn
                color="error"
                small
                @click="cancelStay(item)"
            >
              Annuler
            </v-btn>
            <v-btn
                color="error"
                small
                @click="shortenStay(item)"
            >
              Écouter
            </v-btn>
            <v-btn
                color="error"
                small
                @click="updateStayCustomer(item)"
            >
              Changer de client
            </v-btn>
            <v-btn
                color="success"
                small
                @click="closeStay(item)"
            >
              Clôturer
            </v-btn>
            <v-btn
                color="success"
                small
                @click="updateStayLeavingDate(item)"
            >
              Reconduire
            </v-btn>
            <v-btn
                color="error"
                small
                @click="updateStayRoom(item)"
            >
              Reloger
            </v-btn>
          </div>
          <v-btn
              color="primary"
              small
              @click="showInvoice(item)"
          >
            Imprimer la facture
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <!--    dialog to modify stay begin-->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-btn
                  color="primary"
                  @click="dialog = false"
              >
                <mdi-close-circle/>
                Fermer
              </v-btn>&emsp;
              <v-toolbar-title class="text--white">
                Modification du sejour
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                    color="primary"
                    class="mt-4"
                    @click="dialog = false"
                >
                  Sauvegarder
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      label="Legal first name*"
                      required
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      label="Legal middle name"
                      hint="example of helper text only on focus"
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      label="Legal last name*"
                      hint="example of persistent helper text"
                      persistent-hint
                      required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      label="Email*"
                      required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      label="Password*"
                      type="password"
                      required
                  ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-select
                      :items="['0-17', '18-29', '30-54', '54+']"
                      label="Age*"
                      required
                  ></v-select>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                >
                  <v-autocomplete
                      :items="[
                      'Skiing',
                      'Ice hockey',
                      'Soccer',
                      'Basketball',
                      'Hockey',
                      'Reading',
                      'Writing',
                      'Coding',
                      'Basejump',
                    ]"
                      label="Interests"
                      multiple
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--    dialog to modify stay end-->
    <!--    dialog to create client begin-->
    <NewCustomer></NewCustomer>
    <!--    dialog to create client end-->
    <!--    dialog to update stay infos begin-->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="active_stay_u_infos"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title color="white">
                Modifier les infos de ce sejour
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
              <v-form class="multi-col-validation">
                <v-row style="margin-top: 1%">
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_info.stays_number_of_occupants "
                        type="number"
                        dense
                        hide-details
                        label="Nombre d'occupants"
                        outlined
                        placeholder="Occupants"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_info.stays_number_of_children "
                        type="number"
                        dense
                        hide-details
                        label="Nombre d'enfants"
                        outlined
                        placeholder="Enfants"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        color="primary"
                        @click="active_stay_u_infos = false"
                    >
                      Annuler
                    </v-btn>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        style="margin-left: 1rem; margin-right: 1rem"
                        color="primary"
                        @click="updateStay()"
                    >
                      Modifier
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--    dialog to update stay infos end-->
    <!--    dialog to update stay leaving date begin-->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="active_stay_u_leaving_date"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title color="white">
                Modifier la date de sortir de ce séjour
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
              <v-form class="multi-col-validation">
                <v-row style="margin-top: 1%">
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_leaving_date.old_date"
                        dense
                        hide-details
                        label="Ancienne Date de sortir"
                        outlined
                        placeholder="Date precedente"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_leaving_date.new_date"
                        type="date"
                        dense
                        hide-details
                        label="Nouvelle date de sortir"
                        outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        color="primary"
                        @click="active_stay_u_leaving_date = false"
                    >
                      Annuler
                    </v-btn>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        style="margin-left: 1rem; margin-right: 1rem"
                        color="primary"
                        @click="ChangeStayLeavingDate"
                    >
                      Modifier
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--    dialog to update stay leaving date end-->
    <!--    dialog to update stay customer begin-->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="active_stay_u_customer"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title color="white">
                Changer le client lier a ce séjour
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
              <v-form class="multi-col-validation">
                <v-row style="margin-top: 1%">
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_customer.old_customer"
                        dense
                        hide-details
                        label="Ancien client"
                        outlined
                        placeholder="client precedent"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-select
                        v-model="update_stay_customer.customer_id"
                        dense
                        :items="client_list"
                        label="Nouveau Client"
                        outlined
                        :item-value="'id'"
                        :item-text="item=> item.cust_lastname +' '+ item.cust_firstname+ ':' + item.cust_contact"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        color="primary"
                        @click="active_stay_u_customer = false"
                    >
                      Annuler
                    </v-btn>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        style="margin-left: 1rem; margin-right: 1rem"
                        color="primary"
                        @click="changeStayCustomer"
                    >
                      Modifier
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--    dialog to update stay customer end-->
    <!--    dialog to update stay room begin-->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="active_stay_u_room"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title color="white">
                Reloger le client de ce séjour
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
              <v-form class="multi-col-validation">
                <v-row style="margin-top: 1%">
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-text-field
                        v-model="update_stay_room.old_room"
                        dense
                        hide-details
                        label="Ancienne chambre"
                        outlined
                        placeholder="chambre precedente"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-select
                        v-model="update_stay_room.new_room"
                        dense
                        :items="room_list"
                        label="Nouvelle Chambre"
                        outlined
                        :item-value="'id'"
                        :item-text="'room_name'"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        color="primary"
                        @click="active_stay_u_room = false"
                    >
                      Annuler
                    </v-btn>
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                  >
                    <v-btn
                        style="margin-left: 1rem; margin-right: 1rem"
                        color="primary"
                        @click="changeStayRoom"
                    >
                      Modifier
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--    dialog to update stay room end-->
    <!--  <v-card>-->
    <!--  </v-card>-->
  </div>
</template>

<script>
import {mdiCloseCircle, mdiDotsVertical, mdiSquareEditOutline} from '@mdi/js'
// eslint-disable-next-line import/extensions,import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import {excel2json, json2excel} from 'js2excel'
import {VAutocomplete, VCard, VContainer, VDialog, VForm, VSelect, VTextField,} from 'vuetify/lib/components'
import {VBtn, VCol, VDataTable, VRow, VSpacer, VToolbar, VToolbarTitle,} from 'vuetify'
import NewCustomer from "@/views/stay/NewCustomer.vue";
import NewStay from "@/views/stay/NewStay.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Stay',
  components: {
    NewStay,
    NewCustomer,
    mdiCloseCircle,
    VForm,
    VContainer,
    VCard,
    VDialog,
    VTextField,
    VSelect,
    VAutocomplete,
    VToolbarTitle,
    VRow,
    VCol,
    VBtn,
    VDataTable,
    VSpacer,
    VToolbar,
  },
  setup() {
    const statusColor = {
      /* eslint-disable key-spacing */
      En_cours: 'primary',
      Cloturé: 'success',
      Annulé: 'warning',
      Resigned: 'warning',
      Réservé: 'info',
      Attente_confirmation: 'info',
      Applied: 'info',
      /* eslint-enable key-spacing */
    }

    return {
      headers: [
        {text: 'REFERENCE', value: 'id'},
        {text: 'TYPE DE SÉJOUR', value: 'stay_type.stay_typ_name'},
        {text: 'CHAMBRE CONCERNE', value: 'room.room_name'},
        {text: 'CLIENT', value: 'customer.fullname'},
        {text: "DATE D'ENREGISTREMENT", value: 'stays_date'},
        {text: 'PRIX DU SÉJOUR', value: 'stays_total_price_to_pay_fcfa'},
        {text: 'STATUS', value: 'stays_status'},
      ],
      usreList: [],
      status: {
        250: 'Attente_confirmation',
        300: 'Réservé',
        400: 'En_cours',
        200: 'Cloturé',
        500: 'Annulé',
        550: 'Écourter',
        5: 'Applied',
      },
      statusColor,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
      },
    }
  },
  data() {
    return {
      search: '',
      calories: '',
      filtreTable: 400,
      client_list: [],
      room_list: [],
      listStatus: [
        {name: 'attente-confirmation', code: 250},
        {name: 'reservé', code: 300},
        {name: 'en cours', code: 400},
        {name: 'terminer', code: 200},
        {name: 'annuler', code: 500},
        {name: 'écouter', code: 550},
        {name: 'tous les séjours', code: 0},
      ],
      stay_temp: {},
      stayList: [],
      stayBackup: [],
      expanded: [],
      singleExpand: false,
      dialog: false,
      createClient: false,
      active_stay_u_infos: false,
      active_stay_u_leaving_date: false,
      active_stay_u_customer: false,
      active_stay_u_room: false,
      update_stay_info: {
        stays_number_of_occupants: 0,
        stays_number_of_children: 0,
      },
      update_stay_leaving_date: {
        old_date: '',
        new_date: '',
      },
      update_stay_customer: {
        old_customer: '',
        customer_id: 0,
      },
      update_stay_room: {
        old_room: '',
        new_room: 0,
      },
    }
  },
  computed: {},
  mounted() {
    this.loadStays()
    this.loadCustomer()
    this.loadRoom()
  },
  methods: {
    createStay() {
      this.$router.push('/stay/add')
    },
    filterStay() {
      // eslint-disable-next-line radix
      this.stayList = this.stayBackup
      // eslint-disable-next-line radix
      this.stayList = this.stayList.filter(st => (parseInt(st.stays_status) === this.filtreTable)).length
          // eslint-disable-next-line radix
          ? this.stayList.filter(st => (parseInt(st.stays_status) === this.filtreTable)) : this.stayBackup
    },
    loadRoom() {
      this.$axios.get(this.$endpoint.LoadRoom).then(rp => {
        this.room_list = rp.data
        this.room_list = this.room_list.filter(room => room.room_status === 400)
      })
    },
    modified_stay(stay) {
      this.active_stay_u_infos = true
      this.update_stay_info.stays_number_of_occupants = stay.stays_number_of_occupants
      this.update_stay_info.stays_number_of_children = stay.stays_number_of_children
      this.stay_temp = stay
    },
    loadCustomer() {
      this.$axios.get(this.$endpoint.LoadCustomer).then(rp => {
        this.client_list = rp.data
      })
    },
    totalPay(payments) {
      let total = 0
      for (let e = 0; e < payments.length; e++) {
        total += payments[e].pay_stay_amount
      }

      return total
    },
    updateStayLeavingDate(stay) {
      this.active_stay_u_leaving_date = true
      this.update_stay_leaving_date.old_date = stay.stays_leaving_date
      this.stay_temp = stay
    },
    updateStayCustomer(stay) {
      this.active_stay_u_customer = true
      this.update_stay_customer.old_customer = stay.customer.fullname
      this.stay_temp = stay
    },
    updateStayRoom(stay) {
      this.active_stay_u_room = true
      this.stay_temp = stay
      this.update_stay_room.old_room = stay.room.room_name
    },
    changeStayRoom() {
      this.$axios.patch(this.$endpoint.ChangeStayRoom(this.stay_temp.id), {room_id: this.update_stay_room.new_room}).then(rp => {
        this.active_stay_u_room = false
        this.loadStays()
      })
    },
    changeStayCustomer() {
      this.$axios.patch(this.$endpoint.ChangeStayCustomer(this.stay_temp.id), {customer_id: this.update_stay_customer.customer_id}).then(rp => {
        console.log(rp)
        this.loadStays()
        this.active_stay_u_customer = false
      })
    },
    ChangeStayLeavingDate() {
      this.$axios.patch(this.$endpoint.ChangeStayLeavingDate(this.stay_temp.id), {stays_leaving_date: this.update_stay_leaving_date.new_date}).then(rp => {
        this.loadStays()
        this.active_stay_u_leaving_date = false
      })
    },
    showInvoice(stay) {
      this.$axios.patch(this.$endpoint.ShowStayInvoice, stay).then(rp => {
        this.loadStays()
        window.open(rp.data.invoice, '_blank')
      })
    },
    cancelStay(stay) {
      this.$axios.patch(this.$endpoint.CancelStay(stay.id), stay).then(() => {
        this.loadStays()
      })
    },
    shortenStay(stay) {
      this.$axios.patch(this.$endpoint.ShortenStay(stay.id), stay).then(rp => {
        this.loadStays()
        window.open(rp.data.invoice, '_blank')
      })
    },
    closeStay(stay) {
      this.$axios.patch(this.$endpoint.CloseStay(stay.id)).then(() => {
        this.loadStays()
      })
    },
    updateStay() {
      this.$axios.patch(this.$endpoint.UpdateStay(this.stay_temp.id), this.update_stay_info).then(rp => {
        this.loadStays()
        this.active_stay_u_infos = false
      })
    },
    loadStays() {
      this.$axios.get(this.$endpoint.LoadStay).then(rp => {
        this.stayList = rp.data
        this.stayBackup = rp.data
      })
    },

    exportToExcel() {
      try {
        const excelData = []
        this.stayList.map(item => {
          excelData.push({
            Date_enregistrement: item.stays_date,
            Type_de_sejour: item.stay_type.stay_typ_name,
            Appartement_Concerner: item.room.room_name,
            Client: item.customer.fullname,
            Montant_total_du_sejour: item.stays_total_price_to_pay_fcfa,
            Status_du_sejour: item.stays_status,
            Montant_restant_a_payer: item.stays_remaining_amount,
            Nombre_occupants: item.stays_number_of_occupants,
            Sejour_enregistrer_par: item.user.email,
            Date_entrer: item.stays_enter_date,
            Date_de_sortir: item.stays_leaving_date,
            Nombre_de_nuitee: item.stays_number_of_days,
          })
        })
        json2excel({
          data: excelData,
          name: 'list_sejours',
          formateDate: 'yyyy/mm/dd',
        })
      } catch (e) {
        console.error('export error: ', e)
      }
    },
    checkOption(item) {
      return item.stays_status == 400 || item.stays_status == 300
    },

  },
}
</script>

<style scoped>
</style>
